<template>
    <div class="result-bar" :class="{'result-bar--open': showSearchWidget, 'result-bar--notification': notification}">
        <div class="result-bar__search" @click="showSearchWidget = !showSearchWidget">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.01 32.01" class="result-bar__search__icon"><path d="M19.93,17.44a11,11,0,1,0-2.49,2.49L28,32l4-4ZM11,19a8,8,0,1,1,8-8A8,8,0,0,1,11,19Z"/></svg>
            <div class="result-bar__search__text">
                <span>{{ destination.name }}, {{ dates }}</span>
                <span v-text="numberOfTravelers"></span>
            </div>
        </div>
        <div class="search-component" v-if="showSearchWidget">
            <search-widget 
                ref="searchwidget"
                :showFlexibleDateInfoBox="showFlexInfo" 
                @hideflexibleinfo="showFlexInfo = false"
            ></search-widget>
        </div>
        <search-sort></search-sort>
        <offer-counter></offer-counter>
    </div>
</template>

<script type="text/javascript">
    import OfferCounter from './offer-counter.vue';
    import Moment from 'moment';
    import SearchWidget from './search-widget.vue';
    import SearchSort from './search-sort.vue';
    import CookieJS from 'js-cookie';

    export default {
        props: {
            showSearch: {type: Boolean, default: false}
        },
        data() {
            return {
                translations: APP_CONFIG.TRANSLATION.RESULT_BAR,
                showSearchWidget: false,
                deviceWith: 0,
                showFlexInfo: false
            }
        },
        mounted() {
            this.deviceWith = window.innerWidth;
            if(!this.mobileActive) {
                this.showSearchWidget = true;
            }

            if(this.flexibleDaysInfo) {
                this.showFlexInfo = this.checkFlexibleDatesInfo();
            }
        },
        watch: {
            showSearch() {
                if(this.showSearch) {
                    this.showSearchWidget = true;
                }
            },
            flexibleDaysInfo() {
                if(this.flexibleDaysInfo) {
                    this.showFlexInfo = this.checkFlexibleDatesInfo();                    
                }
            },
            showFlexInfo() {
                if(this.showFlexInfo && !this.mobileActive) {
                    setTimeout(() => {
                        this.showFlexInfo = false;
                    }, 10000);
                }
            },
            showSearchWidget() {
                if(this.showFlexInfo && this.mobileActive) {
                    setTimeout(() => {
                        this.showFlexInfo = false;
                    }, 5000);
                }
            }
        },
        methods: {
            checkFlexibleDatesInfo() {
                if(!CookieJS.get('hide-flexible-dates-info')) {
                    let expires = Moment().add(1, 'years').toDate();
                    CookieJS.set('hide-flexible-dates-info', true, {expires});
                    return true;
                }

                return false;
            },
            openCalendar() {
                this.showSearchWidget = true;
                this.$nextTick(() => {
                    this.$refs.searchwidget.openCalendar();
                })
            }
        },
        computed: {
            mobileActive() {
                return (this.deviceWith <= 600);
            },
            dates() {
                if(!this.travelQuery.fromDate || !this.travelQuery.toDate) {
                    return '';
                }

                return this.travelQuery.fromDate.format('DD. MMMM') + ' - ' + this.travelQuery.toDate.format('DD. MMMM');
            },
            travelQuery() {
                return this.$store.getters.travelQuery;
            },
            destination() {
                return this.$store.state.destination;
            },
            flexibleDaysInfo() {
                return this.travelQuery.flexibleStartDays <= 0 && this.travelQuery.flexibleEndDays <= 0 ? true : false;
            },
            notification() {
                return !this.showSearchWidget && this.showFlexInfo ? true : false;
            },
            numberOfTravelers() {
                if(!this.travelQuery.adults || !this.travelQuery.children) {
                    return '';
                }

                let str = this.travelQuery.adults.toString() + ' ';
                str += (this.travelQuery.adults > 1 || this.travelQuery.adults === 0) ? this.translations.adults : this.translations.adult_single;
                str += ', ' + this.travelQuery.childrenCount + ' ';
                str += (this.travelQuery.childrenCount > 1 || this.travelQuery.childrenCount === 0) ? this.translations.children : this.translations.children_single;
                return str;
            },
        },
        components: {
            'offer-counter': OfferCounter,
            'search-widget': SearchWidget,
            SearchSort
        }
    }
</script>